import React from 'react';

import { retentionCharts, retentionViews } from '../../constants/retention';
import Chart from '../../chart/complexRetention/Chart';
import RetentionTableResult from './RetentionTableResult';

const RetentionResult = (props) => {
  const { options } = props;

  return (
    <>
      {options.view === retentionViews.TABLE && <RetentionTableResult {...props} />}
      {retentionCharts.includes(options.view) && <Chart {...props} />}
    </>
  );
};

export default RetentionResult;
